import { render, staticRenderFns } from "./AboutParentingArrangements.vue?vue&type=template&id=d906ada4"
import script from "./AboutParentingArrangements.vue?vue&type=script&lang=ts"
export * from "./AboutParentingArrangements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports